<!-- =========================================================================================
    File Name: Recommend.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="analyze-item-list" v-if="['SFM', 'SSM'].includes(artefact.type)">
    <!-- <pre>{{units.sku.data}}</pre> -->
    <!-- <vs-tabs v-if="['SFM', 'SSM'].includes(artefact.type)">
      <vs-tab label="Categories" icon-pack="feather" icon="icon-home"> -->
        <div class="vx-row" v-if="type === 'category'">
          <div class="vx-col w-full mb-base">
              <vx-card :title="artefact.type === 'SFM' ? 'Top Selling Categories by Rate of Sale' : 'Slow Moving Categories by Rate of Sale'">
                <vs-table pagination max-items="10" search :data="units.category.data">

                  <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th sort-key="long_description" v-if="showCol('category', 'long_description')">SKU Desc</vs-th>
                    <vs-th sort-key="product_category" v-if="showCol('category', 'product_category')">Category</vs-th>
                    <vs-th sort-key="brand" v-if="showCol('category', 'brand')">Brand</vs-th>
                    <vs-th sort-key="quantity" v-if="showCol('category', 'quantity')">Units/Day</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                      <vs-td :data="data[indextr].long_description" v-if="showCol('category', 'long_description')">
                        {{ data[indextr].long_description }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                      </vs-td>

                      <vs-td :data="data[indextr].brand" v-if="showCol('category', 'brand')">
                        {{ data[indextr].brand }}
                      </vs-td>

                      <vs-td :data="data[indextr].product_category" v-if="showCol('category', 'product_category')">
                        {{ data[indextr].product_category }}
                      </vs-td>

                      <vs-td :data="data[indextr].quantity" v-if="showCol('category', 'quantity')">
                        {{ data[indextr].quantity | numFormat('0.00') }}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
          </div>
        </div>
      <!-- </vs-tab>
      <vs-tab label="SKUs" icon-pack="feather" icon="icon-home"> -->
        <div class="vx-row" v-if="type === 'sku'">
          <div class="vx-col w-full mb-base">
              <vx-card :title="artefact.type === 'SFM' ? 'Top Selling SKUs by Rate of Sale' : 'Slow Selling SKUs by Rate of Sale'">
                <vs-table pagination max-items="10" search :data="units.sku.data">

                  <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th sort-key="desc" v-if="showCol('sku', 'desc')">SKU Desc</vs-th>
                    <vs-th sort-key="product_category" v-if="showCol('sku', 'product_category')">Category</vs-th>
                    <vs-th sort-key="brand" v-if="showCol('sku', 'brand')">Brand</vs-th>
                    <vs-th sort-key="quantity" v-if="showCol('sku', 'quantity')">Units/Day</vs-th>
                    <vs-th sort-key="ctc">CTC ( {{ '' | currencySymbol }} )</vs-th>
                    <vs-th sort-key="inventory">Inventory</vs-th>
                    <vs-th sort-key="is_alert" v-if="showCol('sku', 'is_alert')">Alert</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                      <vs-td :data="data[indextr].desc" v-if="showCol('sku', 'desc')">
                        {{ data[indextr].desc }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                      </vs-td>

                      <vs-td :data="data[indextr].product_category" v-if="showCol('sku', 'product_category')">
                        {{ data[indextr].product_category }}
                      </vs-td>

                      <vs-td :data="data[indextr].brand" v-if="showCol('sku', 'brand')">
                        {{ data[indextr].brand }}
                      </vs-td>

                      <vs-td :data="data[indextr].quantity" v-if="showCol('sku', 'quantity')">
                        {{ data[indextr].quantity | numFormat('0.00') }}
                      </vs-td>
                      
                      <vs-td :data="data[indextr].ctc">
                        {{ '~' | numFormat }}
                      </vs-td>

                      <vs-td :data="data[indextr].inventory">
                        {{ '~' | numFormat }}
                      </vs-td>

                      <vs-td :data="data[indextr].is_alert" v-if="showCol('sku', 'quantity')">
                        <feather-icon icon="AlertTriangleIcon" svgClasses="w-6 h-6 text-danger" v-if="data[indextr].is_alert === 1"></feather-icon>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </vx-card>
          </div>
        </div>
      <!-- </vs-tab>
    </vs-tabs> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {fetchArtefactUnit} from "../shared/services";


export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  data() {
    return {
      showStatsPanel: true,
      popupActive: false,
      colorx:"#e1e1e1",

      unitSelected: [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      units: {
        category: {
          headers: [],
          data: []
        },
        sku: {
          headers: [],
          data: []
        }        
      }
    };
  },
  watch: {},
  computed: {
    // ...mapGetters({order: "analyze/artefactUnit"})
  },
  methods: {
    fetchUnits(type) {
      this.units[type].data = this.formatItemsData(type);
      if(this.units[type] && this.units[type].data.length > 0) {
        this.units[type].headers = Object.keys(this.units[type].data[0]);
      }
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(this.artefact.type, this.artefact.res.trend[type]);
      if(this.artefact.type === 'SFM') {
        return units.reverse();  
      } else {
        return units;
      }
    },
    filterAndSortData(type, data) {

      let filteredData = data.filter(
        t => (type === 'SFM' ? t.type === 'fast' : t.type === 'slow')
      );
      return filteredData;
    },
    showCol(type, key) {
      return this.units[type].headers.includes(key);
    }    
  },
  mounted() {
    this.fetchUnits('category');
    this.fetchUnits('sku');
  },
  components: {
  }
};
</script>

<style lang="scss">
#analyze-item-list {
  .greet-user{
    position: relative;
    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>